import type { QueryClient } from '@tanstack/react-query';

import type { EntityKey, IntegrationCompaniesResponse, RemoteCompany } from './types';

/**
 * Builds canonical entity_keys for preview/ensure from list payload.
 * Providers may send entity_keys; otherwise we derive a siren key from registration_number when present.
 */
export const buildEntityKeysFromRemoteCompany = (item: RemoteCompany): EntityKey[] => {
  if (Array.isArray(item.entity_keys) && item.entity_keys.length > 0) {
    return item.entity_keys.map((e) => ({
      type: e.type,
      value: e.value,
      ...(e.country !== undefined && e.country !== '' ? { country: e.country } : {}),
    }));
  }
  const reg = item.registration_number?.trim();
  if (reg !== undefined && reg !== '') {
    return [{ type: 'siren', value: reg }];
  }
  return [];
};

export const getEntityKeysMapFromCache = (
  queryClient: QueryClient,
  connectionId: string,
): Map<string, EntityKey[]> => {
  const map = new Map<string, EntityKey[]>();
  const queries = queryClient.getQueriesData<IntegrationCompaniesResponse>({
    queryKey: ['integration-companies', connectionId],
  });
  for (const [, data] of queries) {
    if (!data) continue;
    for (const item of data.items) {
      map.set(item.remote_company_id, buildEntityKeysFromRemoteCompany(item));
    }
  }
  return map;
};
